import { Controller } from "@hotwired/stimulus"

// Play/Stop w ustawieniach modułu (organize/settings/_admin_section). Górny pasek (topChange): jeden wybór
// "ukryty / tylko start-przerwa-stop / wpisy WorkInfo" zapisuje dwa klucze konta - widoczność
// (organize.workinfo.start_stop, user może ją nadpisać w /toolkit/ui/settings) i tryb (organize.workinfo.play_mode).
// "Odnotowuj początek i koniec pracy" (wiersz `logWorkday`) ma sens tylko przy wpisach.
// Zadania (taskChange): ten sam wybór to jeden klucz organize.workinfo.task_play.
export default class extends Controller {
  static targets = ["logWorkday"]

  topChange(event) {
    const select = event.target
    const options = { check: select, target: "organize_setting" }
    const mode = topPlayChange(select.value)
    window.IntumJs.setField("organize.workinfo.start_stop", mode.visible, options)
    if (mode.playMode) window.IntumJs.setField("organize.workinfo.play_mode", mode.playMode, options)
    if (mode.playMode && this.hasLogWorkdayTarget) {
      this.logWorkdayTarget.classList.toggle("hidden", mode.playMode !== "entries")
    }
  }

  taskChange(event) {
    const select = event.target
    window.IntumJs.setField("organize.workinfo.task_play", select.value, { check: select, target: "organize_setting" })
  }
}

// Wybór z selecta -> { visible, playMode } (playMode null - ukryty przycisk zostawia zapisany tryb)
export function topPlayChange(value) {
  if (value === "hidden") return { visible: false, playMode: null }
  return { visible: true, playMode: value }
}
